var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 100,
    viewBox: "0 0 97 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H96.242V100H0V0Z",
    fill: "#F7DF1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3058 83.5671L32.6709 78.9358C34.0917 81.5535 35.3843 83.7682 38.4846 83.7682C41.4565 83.7682 43.3302 82.5603 43.3302 77.8619V45.9095H52.3745V77.9947C52.3745 87.7281 46.8835 92.1584 38.8724 92.1584C31.6373 92.1584 27.4374 88.2649 25.3056 83.5663",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2868 82.5603L64.651 78.13C66.5896 81.4195 69.1091 83.8359 73.5665 83.8359C77.314 83.8359 79.7037 81.889 79.7037 79.2039C79.7037 75.9819 77.2489 74.8406 73.1142 72.9617L70.8537 71.9541C64.3284 69.0682 59.9998 65.4435 59.9998 57.7909C59.9998 50.7427 65.168 45.3724 73.2437 45.3724C78.9935 45.3724 83.1281 47.4535 86.0995 52.8908L79.0577 57.5894C77.5071 54.7032 75.8279 53.5622 73.2439 53.5622C70.5951 53.5622 68.9153 55.3074 68.9153 57.5894C68.9153 60.4087 70.5951 61.5501 74.4709 63.2955L76.7318 64.3024C84.4197 67.726 88.7483 71.2162 88.7483 79.0697C88.7483 87.5281 82.3527 92.1593 73.7605 92.1593C65.3621 92.1593 59.9353 87.9978 57.287 82.5603",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.f1ffc0877b9ddff9751bd4e247145703.svg";
export { ForwardRef as ReactComponent };